import React from "react";
import { Download, Info } from "lucide-react";
import { BACKEND_URL, downloadFile } from "../../../lib/api";

export const Tip = ({ text }) => (
  <span title={text} className="inline-flex items-center text-zinc-500 hover:text-purple-400 cursor-help">
    <Info size={14} />
  </span>
);

export const Step = ({ n, title, desc, children }) => (
  <div className="rounded-xl border border-white/10 bg-[#121212] p-5">
    <div className="flex items-start gap-3 mb-3">
      <span className="shrink-0 w-7 h-7 rounded-full bg-purple-600 flex items-center justify-center text-sm font-bold">{n}</span>
      <div>
        <h4 className="font-semibold">{title}</h4>
        {desc && <p className="text-xs text-zinc-500 mt-0.5">{desc}</p>}
      </div>
    </div>
    {children}
  </div>
);

export const MediaThumbs = ({ images, videos }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
    {images.map((img, i) => (
      <div key={img.content_id} className="rounded-xl border border-white/10 overflow-hidden bg-black">
        <img src={`${BACKEND_URL}${img.image_url}`} alt="" className="w-full h-28 object-cover" />
        <button data-testid="download-image" onClick={() => downloadFile(`${BACKEND_URL}${img.image_url}`, `multicontactos-imagen-${i + 1}.jpg`)} className="w-full flex items-center justify-center gap-1.5 text-xs py-2 bg-white/5 hover:bg-purple-600 transition-colors">
          <Download size={13} /> Descargar
        </button>
      </div>
    ))}
    {videos.map((vid, i) => (
      <div key={vid.content_id} className="rounded-xl border border-white/10 overflow-hidden bg-black">
        <video src={vid.video_url} className="w-full h-28 object-cover" />
        <button onClick={() => downloadFile(vid.video_url, `multicontactos-video-${i + 1}.mp4`)} className="w-full flex items-center justify-center gap-1.5 text-xs py-2 bg-white/5 hover:bg-purple-600 transition-colors">
          <Download size={13} /> Descargar
        </button>
      </div>
    ))}
    {images.length === 0 && videos.length === 0 && <p className="text-sm text-zinc-500 col-span-full">No hay imágenes/videos generados.</p>}
  </div>
);
